import React, { useEffect, useState } from "react"
import { Form } from "semantic-ui-react"
import BifrostModalCreateItem from "../../../Components/BifrostPageComponent/BifrostModal/BifrostModalPage/BifrostModalCreateItem"
import { useGetFeatures } from "../../../Hooks/FetchHooks/GetDataService/useGetFeatures"

const AddFeatureToOrgPage = ({ validated, values, setValues, showErrorMessage }) => {
	const { data, isLoading, getFeatures } = useGetFeatures()
	const [featureOptions, setFeatureOptions] = useState([])

	const updateField = (e, name, value) => {
		if (!name) {
			name = e.target.name
			value = e.target.value
		}
		setValues({
			...values,
			[name]: value
		})
	}

	useEffect(() => {
		if (data.length === 0) {
			getFeatures()
		} else {
			setFeatureOptions(data.map((feature) => ({ key: feature.id, value: Number(feature.id), text: feature.name })))
		}
	}, [data])

	return (
		<BifrostModalCreateItem showErrorMessage={showErrorMessage}>
			<Form.Dropdown
				fluid
				search
				selection
				// onOpen={getOrganizations}
				loading={isLoading}
				noResultsMessage="Loading.."
				onChange={(e, { name, value }) => updateField(e, name, value)}
				name="feature_id"
				placeholder="Select feature"
				scrolling
				options={featureOptions}
				error={!validated.feature_id}
			/>
		</BifrostModalCreateItem>
	)
}

export default AddFeatureToOrgPage
